
export class User {
  id?: number;
  email?: string;
  firstName?: string;
  lastName?: string;
  avatar?: string;
  groups?: string[];
}